import React, { memo, useContext } from 'react'
import { useIntl } from 'react-intl'
import type { CellValue, IdType } from 'react-table'
import { ServiceState } from '@racepointenergy/swc/scs/features/host-states'
import { mdiArrowRight } from '@mdi/js'

import { Marking, Mark } from 'components/Mark'
import {
  MobileTableBlock,
  MobileTableBlockCell,
  MobileTableBlockHeader,
  MobileTableBlockRow,
} from 'components/Table/MobileBlock/styles'

import { HomeServicesIcon } from '../../HomeServicesEvents/HomeServicesEventsForm/styles'
import { homeServicesMessages } from '../../messages'
import theme from 'theme_'
import { Body12, BodyPrimary } from 'components/Typography/Labels'
import { SERVICES_HEADERS } from './../../consts'
import { ModalControlContext } from '../../modalControlContext'
import { ShowEventFormPopup } from '../styles'

interface HomeServicesBlockProps {
  values: Record<IdType<ServiceState>, CellValue>
}

export function HomeServicesBlock({ values }: HomeServicesBlockProps) {
  const { formatMessage } = useIntl()
  const modalControlContext = useContext(ModalControlContext)

  return (
    <MobileTableBlock>
      <MobileTableBlockRow>
        <MobileTableBlockHeader>
          {values[SERVICES_HEADERS.IS_ACTIVE] !== undefined && (
            <Mark
              marking={
                values[SERVICES_HEADERS.IS_ACTIVE]
                  ? Marking.Check
                  : Marking.None
              }
            />
          )}
          <BodyPrimary bold color={theme.colors.otterWarmBlack}>
            {values[SERVICES_HEADERS.COMPONENT]}
          </BodyPrimary>
        </MobileTableBlockHeader>
        <ShowEventFormPopup
          type="button"
          onClick={() => modalControlContext.handleModalOpen()}
        >
          <HomeServicesIcon path={mdiArrowRight} size={1} />
        </ShowEventFormPopup>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeServicesMessages.logicalComponentColumn)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values[SERVICES_HEADERS.LOGICAL_COMPONENT]}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeServicesMessages.variantColumn)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values[SERVICES_HEADERS.VARIANT]}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeServicesMessages.serviceTypeColumn)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values[SERVICES_HEADERS.SERVICE_TYPE]}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(homeServicesMessages.zoneColumn)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values[SERVICES_HEADERS.ZONE]}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
    </MobileTableBlock>
  )
}

export default memo(HomeServicesBlock)
